<template>
  <div class="prochain_passage">

    <div class="bloc_info">
      <h1 class="titre">{{ this.$route.params.stopName }}</h1>
      <div class="liens_utiles row">
        <div v-if="stop !== null && stop.stop_lat !== 0 && stop.stop_lon !== 0" class="div_lien_arret col-sm-6 col-12">
          <a :href="'https://maps.google.fr/maps?z=11&t=h&saddr=Ma+position&daddr='+ stop.stop_lat + ',' + stop.stop_lon"
             target="_blank" class="lien_arret"><i class="fas fa-map-marker-alt"></i> Se rendre à l'arrêt</a>
        </div>
      </div>
    </div>

    <div class="div_loader" v-if="loading">
      <b-spinner class="loader" type="grow" label="Spinning"></b-spinner>
    </div>

    <div class="tableau">
      <div class="haut_tableau row">
        <div class="destination col-xl-6 col-sm-7 col-5">
          <span>DESTINATION</span>
        </div>
        <div class="prochain col-xl-4 col-sm-2 col-4">
          <span>PROCHAIN DÉPART</span>
        </div>
      </div>

      <div v-if="passage.stop_depasse === false" :key="passage.trip_id" :style="listPair(index)" class="bus row" v-for="(passage, index) in passages">
        <div class="destination row col-xl-4 col-sm-5 col-5">
          <span class="col-12">{{ passage.headsign }}</span>
        </div>
        <div class="col-xl-2 col-sm-3 col-3">
          <router-link v-if="passage.vehicule_short_id !== 'null'" class="col-12 suivi"
                       :to="{name:'Detail', params: {stopId: passage.stop_id, tripId: passage.trip_id, sequence: passage.sequence}}">
            <span>Suivre le bus</span>
          </router-link>
        </div>
        <div class="prochain col-xl-4 col-sm-2 col-4" v-if="passage.horaire_arrive_reel !== null">
          <span :style="{fontWeight: 'bold'}">Départ immédiat</span>
        </div>

        <div class="prochain col-xl-6 col-sm-4 col-4" style="flex-flow: column;"
             v-else-if="passage.horaire_arrive_estimee !== null">
          <span>{{ passage.horaire_arrive_estimee | filtreTemps }}</span>
          <span
            style="font-size: 0.6em; color: #F08100;">{{
              afficherRetard(passage.horaire_arrive_estimee, passage.horaire_arrive_prevu)
            }}</span>
        </div>

        <div class="prochain col-xl-6 col-sm-4 col-4" v-else>
          <span>{{ passage.horaire_arrive_prevu | filtreTemps }}</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import moment from 'moment'
  import router from '../router'

  export default {
    name: 'ProchainPassage',
    data () {
      return {
        stop: null,
        passages: null,
        timer: '',
        loading: false
      }
    },
    methods: {
      listPair: function (cases) {
        let style = {}
        if (cases % 2 !== 0) {
          style.backgroundColor = '#e7f5f8'
        }
        return style
      },
      affichetrajet: function () {
        this.loading = true
        this.axios
          .get('/prochains-passages/' + this.$route.params.stopName)
          .then((succes) => {
            this.passages = succes.data
            this.loading = false
          }, (error) => {
            console.error('ERREUR de routes pour les trajets', error)
          })
      },
      afficherRetard: function (estimee, prevue) {
        moment.locale('fr')
        console.log(estimee)
        console.log(prevue)
        let diff = moment(estimee).diff(moment(prevue), 'minutes')
        console.log(diff)
        if (diff > 1) {
          return 'retard : ' + diff + ' min'
        } else {
          return ''
        }
      }
    },

    mounted () {
      this.affichetrajet()
      this.timer = setInterval(this.affichetrajet, 60000)
      moment.updateLocale('fr', {
        relativeTime: {
          m: '%dmin',
          mm: '%dmin'
        }
      })
      router.beforeEach((to, from, next) => {
        clearInterval(this.timer)
        next()
      })

      this.axios
        .get('/stop-information/' + this.$route.params.stopName)
        .then((succes) => {
          this.stop = succes.data
          console.log(succes)
        }, (error) => {
          console.error('ERREUR Lors de la récup du stop', error.body)
        })
    },

    filters: {
      filtreTemps: function (horraireArrivee) {
        let date = moment(horraireArrivee)
        moment.locale('fr')
        if (date < moment().add(1, 'minute')) {
          return 'Imminent'
        } else if (date < moment().add(44, 'minute')) {
          return moment(horraireArrivee).fromNow('m')
        } else if (date < moment().endOf('day')) {
          return (moment(horraireArrivee).format('HH') + 'h' + moment(horraireArrivee).format('mm'))
        } else {
          return moment(horraireArrivee).format('DD/MM à HH') + 'h' + moment(horraireArrivee).format('mm')
        }
      }
    }
  }
</script>

<style scoped lang="scss">
@import "src/sass/variables";
@import "node_modules/bootstrap/scss/bootstrap";

.parent {
  display: table-cell;
  vertical-align: middle;
}

.prochain_passage {
  margin-top: 3rem;
  .bloc_info {
    .titre {
      text-align: center;
      font-family: $titlefont;
      color: $secondcolor;
      font-size: 40px;
      font-weight: bold;
      @include media-breakpoint-up(lg) {
        font-size: 70px;
      }
    }

    .liens_utiles {
      margin: 2rem 0 0 0;
      display: flex;

      .div_lien_arret {
        text-align: center;
        display: flex;
        @include media-breakpoint-down(xs) {
          margin-bottom: 1rem;
        }
        .lien_arret {
          text-decoration: none;
          font-size: 30px;
          color: $annexecolor;
          font-family: $textfont;
          margin: auto;
          @include media-breakpoint-up(lg) {
            font-size: 40px;
          }
        }
      }
      .div_lien_reserver {
        text-align: center;
        margin: auto;
        .lien_reserver {
          text-transform: uppercase;
          padding: 1rem;
          font-size: 20px;
          color: $firstcolor;
          background-color: white;
          border: 2px solid $firstcolor;
        }
        .lien_reserver:hover {
          color: white;
          background-color: $firstcolor;
        }
      }
    }
  }

  .div_loader {
    display: flex;
    margin: 4rem 0;
    @include media-breakpoint-up(sm) {
      height: 0;
    }

    .loader {
      margin: auto;
      color: $firstcolor;
      width: 6rem;
      height: 6rem;
    }
  }

  .tableau {
    @include media-breakpoint-down(sm) {
      padding: 1rem;
    }
    padding: 3rem 5rem 5rem 5rem;
    width: 100%;

    .haut_tableau {
      background-color: $firstcolor;
      color: white;

      .ligne, .destination, .prochain {
        border: 0;
        background-color: $firstcolor;

        span {
          margin-top: auto;
          margin-bottom: auto;
        }
      }

      .ligne, .destination {
        @include media-breakpoint-up(lg) {
          font-size: 2.5rem;
        }
        font-size: 1.1rem;
        font-family: $titlefont;
        font-weight: bold;
      }

      .prochain {
        @include media-breakpoint-up(lg) {
          font-size: 1.65rem
        }
        font-size: 15px;
        font-family: $titlefont;
        line-height: 100%;
      }
    }

    .suivi {
      @include media-breakpoint-up(sm) {
        font-size: 0.5rem;
      }
      @include media-breakpoint-up(lg) {
        font-size: 1rem;
      }
      @include media-breakpoint-up(xl) {
        font-size: 1.5rem;
      }
      border: 2px solid $secondcolor;
      background-color: white;
      border-radius: 10px;
      color: $secondcolor;
      font-size: 16px;
      margin: 1rem;
      text-decoration: none;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .suivi:hover {
      background-color: $secondcolor;
      color: white;
    }

    .suivi_text {
      display: block;
      justify-items: center;
      align-items: center;
    }

    .ligne {
      @include media-breakpoint-up(lg) {
        font-size: 2.5rem;
      }
      font-family: $titlefont;
      font-weight: bold;
      border-top: 1px solid white;
      display: flex;

      span {
        margin: auto;
      }

      .div_warning {
        position: absolute;
        right: 10px;
        height: 100%;
        display: flex;

        .warning {
          margin: auto;
          color: $danger;
        }
      }
    }

    .destination {
      @include media-breakpoint-up(lg) {
        padding-left: 5rem;
        font-size: 2.1rem;
      }
      padding-top: 10px;
      padding-bottom: 10px;
      font-family: $textfont;
      text-align: left;
      display: flex;

      span {
        margin: auto 0;
      }

      .liens {
        text-decoration: none;
        color: black;
        display: flex;

        span {
          margin: auto;
        }
      }

      .detail_vehicule {
        margin: auto;
        font-size: 18px;
        text-decoration: none;
        color: $annexecolor;
      }
    }

    .prochain {
      @include media-breakpoint-up(lg) {
        font-size: 1.85rem;
      }
      @include media-breakpoint-up(xl) {
        font-size: 2.4rem;
      }
      margin-left: auto;
      font-family: $textfont;
      display: flex;
      padding: 10px;
      border-bottom: 1px solid white;

      span {
        width: 100%;
        text-align: end;
        margin: auto;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ProchainPassage.vue